import { __awaiter } from '../../../node_modules/tslib/tslib.es6.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { isBrowser, getClassNames } from '@websolutespa/bom-core';
import { IconLlmPlay } from '@websolutespa/bom-mixer-icons';
import { useId, useRef, useState, useEffect } from 'react';

const VideoPlayer = props => {
  const id = useId();
  const playerRef = useRef(null);
  const [loading, setLoading] = useState(true);
  const [playing, setPlaying] = useState(false);
  useEffect(() => {
    if (isBrowser && playerRef.current) {
      const player = playerRef.current;
      const onPlay = () => {
        setPlaying(true);
      };
      const onPause = () => {
        setPlaying(false);
      };
      const onCanPlay = () => {
        setLoading(false);
      };
      player.addEventListener('canplay', onCanPlay);
      player.addEventListener('play', onPlay);
      player.addEventListener('pause', onPause);
      return () => {
        player.removeEventListener('canplay', onCanPlay);
        player.removeEventListener('play', onPlay);
        player.removeEventListener('pause', onPause);
      };
    }
    return () => {};
  }, [playerRef]);
  const onPlay = () => __awaiter(void 0, void 0, void 0, function* () {
    if (playerRef.current) {
      try {
        yield playerRef.current.play();
      } catch (error) {
        console.log('VideoPlayer.onPlay.error', error);
      }
    }
  });
  const onToggle = () => __awaiter(void 0, void 0, void 0, function* () {
    if (playerRef.current) {
      try {
        playing ? yield playerRef.current.pause() : yield playerRef.current.play();
      } catch (error) {
        console.log('VideoPlayer.onToggle.error', error);
      }
    }
  });
  const classNames = getClassNames('llm__video-player', 'llm__video', {
    '-loading': loading,
    '-playing': playing
  });
  return jsxs("div", {
    className: classNames,
    children: [jsx("video", {
      id: id,
      ref: playerRef,
      src: props.media.src,
      muted: true,
      playsInline: true,
      onClick: () => onToggle(),
      "aria-label": playing ? 'Play' : 'Pause'
    }), jsx("button", {
      type: "button",
      className: "llm__video-play",
      onClick: () => onPlay(),
      "aria-label": "Play",
      children: jsx(IconLlmPlay, {})
    })]
  });
};

export { VideoPlayer };
//# sourceMappingURL=video-player.js.map
